<div class="container p-0">
  <mat-dialog-content>
    <div class="modal-dialog my-0">
      <div class="modal-content ml-32 mr-32 mt-10">
        <div class="text-center mb-12">
          <h4 class="text-xl" [innerHtml]="title"></h4>
        </div>
        <div class="modal-body">
          <ng-container>
            <h6 class="text-center mt-5 mb-10" [innerHtml]="message"></h6>
          </ng-container>
          <thera-client-side-list
            [columnDefs]="columnDefinitions"
            [rowData]="inUsePlans"
            noRowsTemplate="No search results found."
          >
          </thera-client-side-list>
        </div>

        <div class="block text-center mb-8 mt-8">
          <div class="mb-5">
            <button mat-button tabindex="-1" (click)="dialog.close(false)">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
